
















































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { format, parseISO } from 'date-fns'
import Agendamento from '@/Apis/Agendamento/Agendamento'
import { groupCollectionByField,
  maskHour,
  timeout,
  timeoutDefault } from '@/utils/common'
import BackofficeModalChatStore from '@/views/backoffice-chat/store/backoffice-modal-chat-store'
import { CancelarSolicitacaoParam,
  PendenciaMensagem,
  TipoDocumentoUpload,
  TipoMensagemEnum,
  TipoOrigemEnum,
  TipoUsuarioEnum } from '@/types/_'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { IPendenciaSolicitacao,
  PendenciaSolicitacao } from '@/types/implements/PendenciaSolicitacao'
import AgendamentoBackofficeApi from '@/Apis/Agendamento/Services/AgendamentoBackofficeApi'
import BackofficeAgendamentoStore from './Store/BackofficeAgendamentoStore'
import HistoricoSolicitacaoStore from '../HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '../SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoCancelamentoStore from '../SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import SolicitacaoPendenciaStore from '../SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'

@Component
export default class ComponentModalPriorizar extends Vue {
  loadingClose: boolean = false
  windowWidth: number = 0
  menuDatePicker = false
  loadPendencia: boolean = false
  modalPendencia: boolean = false
  loadHistorico: boolean = false
  loadComentarios: boolean = false
  loadCancelamento: boolean = false
  loadClosePendencia: boolean = false
  loadMensagem: boolean = false
  loadUpload: boolean = false
  modalConfirmarPendencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadConfirmarPendencia: boolean = false
  loadSubmit: boolean = false
  mensagem: string = ''
  inputFiles: any[] = []
  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Hospital
  pendenciaSolicitacao: IPendenciaSolicitacao = new PendenciaSolicitacao()

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get backofficeModalChatStore() {
    return getModule(BackofficeModalChatStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get showModalPriorizar() {
    return this.getBackofficeGlobalStore.modal.priorizar
  }

  get dateFormatted() {
    const date = this.getBackofficeGlobalStore.solicitacao.dataOpcaoPriorizacao
    return date ? format(parseISO(date), 'dd/MM/yyyy') : ''
  }

  get currentDate() {
    return format(new Date(), 'yyyy-MM-dd')
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingClosePendencia() {
    return this.loadClosePendencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePendencia = value
  }

  get getDisplayPendencia() {
    return {
      nomePaciente: this.getBackofficeGlobalStore.solicitacao.paciente.nome,
      nomeMedico:
        this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome,
    }
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get loadingSubmit() {
    return this.loadSubmit
  }

  set loadingSubmit(val: boolean) {
    this.loadSubmit = val
  }

  async closeModal() {
    this.loadingClose = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await Agendamento.AgendamentoMedicoBackofficeApi.desbloquearAgendamento(
      this.getBackofficeGlobalStore.solicitacao.id,
    )
    await this.getBackofficeGlobalStore.closeModalPriorizar()
    this.getPendenciaStore.clearPendencia()
    this.loadingClose = false
    await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(
      solicitacaoId,
    )
    this.getPendenciaStore.setModalConfirmar(false)
    this.showModalConfirmarPendencia = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(
      solicitacaoId,
    )
    this.loadingHistorico = false
  }

  async openChat() {
    const chatData = {
      solicitationId: this.getBackofficeGlobalStore.solicitacao.id,
      chatArea: 'agendamento',
      recipientName:
        this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome,
      senderId: this.$user.profile.sub,
      senderName: this.$user.profile.name,
    }

    this.backofficeModalChatStore.reset()
    await this.backofficeModalChatStore.openChatModal(chatData)
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: '',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(
      cancelarSolicitacaoParam,
    )
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
    })
    this.loadingCancelamento = false
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(
      solicitacaoId,
      mensagens,
    )

    if (response.success) {
      this.getBackofficeAgendamentoStore.deleteSolicitacao(
        this.getBackofficeGlobalStore.solicitacao.id,
      )
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Houve um erro ao enviar a pendência.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    await timeout(2000)
    this.loadingConfirmarPendencia = false
  }

  async confirmarPriorizar() {
    this.loadingSubmit = true
    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingSubmit = false
      return
    }
    const payload = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      dataOpcaoPriorizacao: this.getBackofficeGlobalStore.solicitacao
        .dataOpcaoPriorizacao
        ? new Date(
          this.getBackofficeGlobalStore.solicitacao.dataOpcaoPriorizacao,
        ).toISOString()
        : null,
    }
    const response = await AgendamentoBackofficeApi.backofficeFazPriorizacao(
      this.getBackofficeGlobalStore.solicitacao.id,
      payload,
    )
    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Solicitação priorizada com sucesso!',
        icon: 'done',
        color: '#2E7D32',
        timeout: 4000,
      })
      await this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Houve um erro ao efetuar priorização.',
        icon: 'warning',
        color: '#C62828',
        timeout: 7500,
      })
    }
    this.loadingSubmit = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
